import { combineReducers } from 'redux';
import { toastMessageStateReducer } from './reducer';

const rootReducer = combineReducers({
  toastMessageStateReducer: toastMessageStateReducer
});

export default rootReducer;
